var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container"},[_c('tip-tap',{attrs:{"readonly":_vm.readOnly || _vm.printView,"label":_vm.printView ? _vm.$t('notAvailable') : _vm.$t('comment'),"hint":_vm.hint},on:{"blur":_vm.leaveField,"focus":_vm.enterField},model:{value:(_vm.commentText),callback:function ($$v) {_vm.commentText=$$v},expression:"commentText"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }